import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { GlobalContext } from "../../../app/providers/GlobalState";

const MenuTurma = ({ inicioUrl, menuOpcaoAtivo, acessos, labelDisciplinas }) => {
    const context = useContext(GlobalContext);

    return (
        <div className="menu-detalhe-curso menu-detalhe-curso-v2">
            <div className="container">
                {(!context.chave_entidade && context.role === "UTILIZADOR") || context.role !== "UTILIZADOR" ? (
                    <ul>
                        <li>
                            <Link to={`${inicioUrl}/visao-geral`} className={menuOpcaoAtivo === "visao-geral" ? "ativo" : ""}>
                                {labelDisciplinas}
                            </Link>
                        </li>
                        {acessos?.includes(14) && (
                            <li>
                                <Link to={`${inicioUrl}/horario`} className={menuOpcaoAtivo === "horario" ? "ativo" : ""}>
                                    Diário
                                </Link>
                            </li>
                        )}
                        {console.log("acessos", acessos)}
                        {acessos?.includes(33) && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/educacao-especial`}
                                    className={menuOpcaoAtivo === "educacao-especial" ? "ativo" : ""}
                                >
                                    Educação Especial
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(19) && (
                            <li>
                                <Link to={`${inicioUrl}/ficheiros`} className={menuOpcaoAtivo === "ficheiros" ? "ativo" : ""}>
                                    Drive
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(21) && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/aproveitamento`}
                                    className={menuOpcaoAtivo === "aproveitamento" ? "ativo" : ""}
                                    onClick={() => localStorage.setItem("vista", "TURMA")}
                                >
                                    Avaliações
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(15) && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/relatorios-aproveitamento`}
                                    className={menuOpcaoAtivo === "relatorios-aproveitamento" ? "ativo" : ""}
                                >
                                    Emissão de Documentos
                                </Link>
                            </li>
                        )}
                    </ul>
                ) : (
                    <ul>
                        <li>
                            <Link to={`${inicioUrl}/visao-geral`} className={menuOpcaoAtivo === "visao-geral" ? "ativo" : ""}>
                                {labelDisciplinas}
                            </Link>
                        </li>
                        <li>
                            <Link to={`${inicioUrl}/horario`} className={menuOpcaoAtivo === "horario" ? "ativo" : ""}>
                                Diário
                            </Link>
                        </li>
                        <li>
                            <Link to={`${inicioUrl}/ficheiros`} className={menuOpcaoAtivo === "ficheiros" ? "ativo" : ""}>
                                Drive
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${inicioUrl}/relatorios-aproveitamento`}
                                className={menuOpcaoAtivo === "relatorios-aproveitamento" ? "ativo" : ""}
                            >
                                Emissão de Documentos
                            </Link>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
};

export default MenuTurma;
